import {ProteinCreationTableMetadata} from 'antibodies/nested-data-creation/full-screen/ProteinCreationStructuredTableAdapter';
import {BioentityType} from 'constants/ModelTypeConstants';
import {ProteinNestedComponentColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {CustomEvalResult} from 'notebook/tables/constants/CustomEvalConstants';
import {RowMetadata} from 'notebook/tables/constants/RowConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import {getBioentityInfosFromTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {ResolveQueryFn, ResolveTypedValueToTypeFn} from 'notebook/tables/typed-values/TypedValueResolution';
import APIUtil from 'util/APIUtil';

/**
 * Flags entities whose type is not allowed in a protein component column, e.g. a custom entity in a domain
 * column. The value is resolved first so that typed or pasted entity names are checked as well as chips.
 */
export function proteinNestedComponentColumnCustomEval(
  typedValue: TypedValue,
  columnDefinition: ProteinNestedComponentColumnDefinition,
  cellDependencies: Array<TypedValue | null>,
  customEvalOptions: {tableMetadata: ProteinCreationTableMetadata; rowMetadata: RowMetadata},
  resolveFromResolutionQuery: ResolveQueryFn,
  resolveTypedValueToType: ResolveTypedValueToTypeFn
): CustomEvalResult {
  const {resolvedValue, error} = resolveTypedValueToType(columnDefinition, typedValue);
  if (error != null) {
    return {val: resolvedValue, error, locked: false};
  }
  const disallowedEntity = (getBioentityInfosFromTypedValue(resolvedValue) ?? []).find(
    ({id}) => !columnDefinition.bioentityTypeFilters.includes(APIUtil.apiIdToType(id) as BioentityType)
  );
  return {
    val: resolvedValue,
    error:
      disallowedEntity == null
        ? null
        : new ExcessUtil.ValueError(
            `${disallowedEntity.name} is not an allowed entity type for this column.`
          ),
    locked: false,
  };
}
